module.exports = __webpack_public_path__ + "img/img_kit.d64a5831.png";